export default {
    language: "Français",
    StripeSuccess: {
        loading: "Traitement de votre paiement...",
        successMessage: "Votre abonnement a été activé avec succès !",
        processingError: "Échec du traitement du paiement, veuillez nous contacter",
    },
    Terms: {
        "tabs": {
            "terms": "Conditions d'utilisation",
            "privacy": "Politique de confidentialité",
            "cookies": "Politique relative aux cookies"
        },
        "lastUpdated": "Dernière mise à jour : 20 mai 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Introduction",
                    "description": "Bienvenue sur ClixMagicAI. L'utilisation de nos services implique que vous acceptez ces conditions d'utilisation. Veuillez les lire attentivement."
                },
                {
                    "title": "2. Description du service",
                    "description": "ClixMagicAI fournit des outils basés sur l'IA pour supprimer les filigranes des images et vidéos. Nos services sont destinés aux utilisations légitimes suivantes :",
                    "items": [
                        "Suppression des filigranes de votre propre contenu",
                        "Suppression des filigranes de contenu pour lequel vous disposez des droits appropriés de modification",
                        "À des fins éducatives et de recherche"
                    ]
                },
                {
                    "title": "3. Responsabilités de l'utilisateur",
                    "description": "En utilisant ClixMagicAI, vous acceptez de :",
                    "items": [
                        "Télécharger uniquement du contenu que vous possédez ou pour lequel vous disposez des droits appropriés de modification",
                        "Ne pas utiliser nos services à des fins illégales ou en violation de toute loi",
                        "Ne pas tenter de contourner nos mesures de sécurité ou nos restrictions d'utilisation",
                        "Ne pas utiliser nos services pour enfreindre les droits de propriété intellectuelle d'autrui"
                    ]
                },
                {
                    "title": "4. Conditions du compte",
                    "description": "Vous pourriez avoir besoin de créer un compte pour utiliser certaines fonctionnalités de nos services. Pour vous connecter, vous pouvez choisir d'utiliser un compte Google ou GitHub. Vous êtes responsable de :",
                    "items": [
                        "Maintenir la sécurité de votre compte",
                        "Toutes les activités qui se produisent sous votre compte",
                        "Fournir des informations de compte précises (y compris, mais sans s'y limiter, l'avatar, l'e-mail, le nom d'utilisateur et l'ID utilisateur)"
                    ]
                },
                {
                    "title": "5. Services gratuits et payants",
                    "description": "ClixMagicAI propose un quota de base gratuit et des options d'achat de points flexibles pour accéder à nos fonctionnalités de suppression de filigrane :",
                    "items": [
                        "Quota de base : Chaque utilisateur recevra automatiquement 3 points gratuits par jour, utilisables pour le traitement de contenu",
                        "Règles de consommation des points : La suppression de filigrane d'images consomme 1 point par opération, la suppression de filigrane de vidéo consomme 3 points par opération",
                        "Achat de points : Vous pouvez choisir d'acheter des packs de points pour plus d'utilisation, tous les points achetés sont valables de façon permanente, sans restrictions d'expiration",
                        "Politique de remboursement : En raison de la nature instantanée et virtuelle des services numériques, les points ne peuvent pas être remboursés une fois achetés avec succès"
                    ]
                },
                {
                    "title": "6. Droits de propriété intellectuelle",
                    "description": "Le service ClixMagicAI, y compris tous les logiciels, designs et contenus que nous avons créés, est notre propriété intellectuelle. Vous ne pouvez pas copier, modifier ou créer des œuvres dérivées basées sur nos services sans autorisation."
                },
                {
                    "title": "7. Limitation de responsabilité",
                    "description": "ClixMagicAI fournit le service \"tel quel\", sans garanties d'aucune sorte. Nous ne sommes pas responsables des dommages résultant de votre utilisation de nos services."
                },
                {
                    "title": "8. Modifications des conditions",
                    "description": "Nous pouvons modifier ces conditions à tout moment. L'utilisation continue de ClixMagicAI après la modification des conditions signifie que vous acceptez les conditions modifiées."
                },
                {
                    "title": "9. Résiliation",
                    "description": "Nous nous réservons le droit de mettre fin ou de suspendre votre accès à nos services immédiatement, sans préavis, si nous estimons que votre comportement viole ces conditions ou nuit à d'autres utilisateurs, à nous-mêmes ou à des tiers."
                },
                {
                    "title": "10. Loi applicable",
                    "description": "Ces conditions seront régies par les lois applicables au lieu d'enregistrement de notre société, nonobstant les dispositions relatives aux conflits de lois."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Introduction",
                    "description": "Chez ClixMagicAI, nous valorisons votre vie privée et nous nous engageons à protéger vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre site web et nos services. En accédant à notre site web ou en utilisant l'un de nos services, vous acceptez les pratiques de traitement des données décrites dans cette politique. Nous adhérons aux réglementations applicables en matière de protection des données."
                },
                {
                    "title": "2. Informations que nous collectons",
                    "description": "Nous pouvons collecter les types d'informations suivants :",
                    "items": [
                        { "bold": "Informations de compte", "text": "Avatar d'utilisateur, adresse e-mail, nom d'utilisateur et ID d'utilisateur fournis lors de la connexion via Google ou GitHub" },
                        { "bold": "Données d'utilisation", "text": "Informations sur la façon dont vous utilisez nos services, y compris les fonctionnalités auxquelles vous accédez et le temps d'utilisation" },
                        { "bold": "Contenu téléchargé", "text": "Images ou vidéos que vous téléchargez pour traitement" },
                        { "bold": "Informations de paiement", "text": "Informations de paiement lors de l'achat d'abonnements (traitées en toute sécurité via des passerelles de paiement tierces comme Creem/Stripe/PayPal, nous ne conservons que les enregistrements de statut de paiement)" },
                        { "bold": "Données techniques", "text": "Adresse IP, type de navigateur, informations sur l'appareil" }
                    ]
                },
                {
                    "title": "3. Comment nous utilisons vos informations",
                    "description": "Nous utilisons vos informations pour :",
                    "items": [
                        { "text": "Fournir, maintenir et améliorer nos services" },
                        { "text": "Traiter et compléter les transactions" },
                        { "text": "Envoyer des notifications techniques et des messages de support" },
                        { "text": "Répondre à vos commentaires et questions" },
                        { "text": "Analyser les modèles d'utilisation pour améliorer l'expérience utilisateur, et traiter les données personnelles uniquement dans la mesure nécessaire pour atteindre les objectifs du service" },
                        { "text": "S'assurer que la période de stockage des données personnelles n'excède pas le temps nécessaire" },
                        { "text": "Prévenir la fraude ou les activités illégales" }
                    ]
                },
                {
                    "title": "4. Sécurité des données",
                    "description": "Nous mettons en œuvre des mesures de sécurité conformes aux normes de l'industrie pour protéger vos informations personnelles :",
                    "items": [
                        { "text": "Chiffrement AES-256 pour les fichiers pendant la transmission et le stockage" },
                        { "text": "Traitement des données sensibles utilisant une architecture à connaissance zéro" },
                        { "text": "Audits quotidiens des journaux de sécurité et scans de vulnérabilité" },
                        { "text": "L'accès des employés suit le principe du moindre privilège" }
                    ]
                },
                {
                    "title": "5. Partage de données",
                    "description": "Nous ne vendons pas vos informations personnelles. Nous pouvons partager des informations :",
                    "items": [
                        { "bold": "Fournisseurs de services", "text": "Limité au traitement des données nécessaire pour fournir des services spécifiques (comme le stockage cloud CloundFlare, les passerelles de paiement tierces comme Creem/Stripe/PayPal), qui nécessitent de signer des accords de traitement des données" },
                        { "bold": "Exigences légales", "text": "Lorsque nous recevons une assignation valide, une ordonnance du tribunal ou un autre processus légal qui nous est applicable" }
                    ]
                },
                {
                    "title": "6. Vos droits",
                    "description": "Selon les lois applicables dans votre région, vous pourriez avoir les droits suivants :",
                    "items": [
                        { "text": "Accéder à une copie de vos données personnelles" },
                        { "text": "Rectifier des informations inexactes ou incomplètes" },
                        { "text": "Droit à l'effacement des données ('droit à l'oubli'), à moins que nous ayons une raison légale de les conserver" },
                        { "text": "S'opposer à ou restreindre certains types de traitement de données" },
                        { "text": "Droit à la portabilité des données, vous pouvez demander le transfert de vos données" }
                    ]
                },
                {
                    "title": "7. Confidentialité des enfants",
                    "description": "Nos services ne sont pas destinés aux mineurs de moins de 16 ans. Conformément à l'article 8 du Règlement général sur la protection des données (RGPD), le consentement pour les enfants de moins de 16 ans doit être fourni par un parent ou un tuteur. Si vous apprenez qu'un mineur de moins de 16 ans nous a fourni des informations personnelles, veuillez nous contacter immédiatement à clixmagicai@gmail.com."
                },
                {
                    "title": "8. Modifications de cette politique",
                    "description": "Nous pouvons mettre à jour cette politique de confidentialité périodiquement. Nous vous informerons de tout changement significatif en publiant la nouvelle politique sur cette page et en mettant à jour la date de \"dernière mise à jour\". Pour les changements importants, nous informerons les utilisateurs par e-mail ou d'une autre manière visible."
                },
                {
                    "title": "9. Contactez-nous",
                    "description": "Si vous avez des questions concernant cette politique de confidentialité, veuillez nous contacter à clixmagicai@gmail.com. Si vous pensez que vos données ont été traitées de manière inappropriée ou si vous avez des préoccupations, n'hésitez pas à nous contacter à tout moment."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. Que sont les cookies",
                    "description": "Les cookies sont de petits fichiers texte placés sur votre ordinateur ou appareil mobile lorsque vous visitez un site web. Ils permettent aux sites web de reconnaître votre appareil et de se souvenir si vous avez déjà visité le site."
                },
                {
                    "title": "2. Comment nous utilisons les cookies",
                    "description": "ClixMagicAI utilise des cookies à plusieurs fins :",
                    "items": [
                        { "bold": "Cookies nécessaires", "text": "Requis pour la fonctionnalité de base de notre site web (comme la gestion de session et les fonctionnalités de sécurité)" },
                        { "bold": "Cookies de préférences", "text": "Se souviennent de vos réglages et préférences pour améliorer votre expérience, par exemple en se souvenant de votre avatar, nom d'utilisateur, etc. après vous être connecté via Google ou GitHub" },
                        { "bold": "Cookies d'analyse", "text": "Nous aident à comprendre comment les visiteurs interagissent avec notre site web en collectant des informations anonymes" },
                        { "bold": "Cookies de marketing", "text": "Suivent vos habitudes de navigation pour offrir des publicités pertinentes à vos intérêts" }
                    ]
                },
                {
                    "title": "3. Types de cookies que nous utilisons",
                    "subsection": [
                        {
                            "title": "3.1 Cookies nécessaires",
                            "description": "Ces cookies sont essentiels au bon fonctionnement du site web. Ils permettent des fonctions centrales telles que la sécurité, la gestion du réseau et l'accès au compte (y compris la connexion via Google et GitHub). Vous pouvez configurer votre navigateur pour bloquer ces cookies, mais certaines parties du site web risquent de ne pas fonctionner correctement."
                        },
                        {
                            "title": "3.2 Cookies de performance et d'analyse",
                            "description": "Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site web en collectant des informations anonymes. Nous utilisons ces données pour améliorer notre site web et nos services. Ces cookies ne collectent pas d'informations pouvant identifier un visiteur."
                        },
                        {
                            "title": "3.3 Cookies de fonctionnalité",
                            "description": "Ces cookies permettent à notre site web de se souvenir des choix que vous faites (comme les préférences de langue ou l'état de connexion) pour fournir des fonctionnalités personnalisées améliorées, comme se souvenir de votre état de connexion via Google ou GitHub."
                        },
                        {
                            "title": "3.4 Cookies de ciblage et de publicité",
                            "description": "Ces cookies sont utilisés pour afficher des publicités pertinentes aux visiteurs et suivre l'efficacité de nos campagnes publicitaires. Veuillez noter que, comme notre site web s'appuie principalement sur des connexions tierces (Google et GitHub), ce type de cookies est principalement utilisé pour améliorer l'expérience utilisateur et non pour le marketing direct."
                        }
                    ]
                },
                {
                    "title": "4. Gestion des cookies",
                    "description": "Vous pouvez contrôler et gérer les cookies de différentes manières. La plupart des navigateurs web permettent de gérer les préférences de cookies. Vous pouvez :",
                    "items": [
                        { "text": "Supprimer les cookies de votre appareil" },
                        { "text": "Bloquer les cookies en activant les paramètres de votre navigateur qui vous permettent de refuser certains ou tous les cookies" },
                        { "text": "Configurer votre navigateur pour qu'il vous avertisse lorsque vous recevez des cookies" }
                    ]
                },
                {
                    "title": "5. Cookies tiers",
                    "description": "Certains cookies sont placés par des tiers sur notre site web. Ces tiers peuvent inclure des services d'analyse (comme Google Analytics) et des réseaux publicitaires. En raison du fonctionnement des cookies (les cookies ne peuvent être accessibles que par la partie qui les a initialement placés), nous ne contrôlons pas l'utilisation de ces cookies tiers et ne pouvons pas y accéder. Pour les utilisateurs qui se connectent via Google et GitHub, nous nous assurerons de suivre les directives de confidentialité de ces plateformes lors du traitement des informations pertinentes."
                },
                {
                    "title": "6. Mise à jour de cette politique relative aux cookies",
                    "description": "Nous pouvons mettre à jour cette politique relative aux cookies de temps à autre pour refléter les changements dans la technologie, les réglementations ou nos pratiques commerciales. Tout changement sera publié sur cette page et la date de révision sera mise à jour."
                },
                {
                    "title": "7. Contactez-nous",
                    "description": "Si vous avez des questions concernant notre utilisation des cookies, veuillez nous contacter à clixmagicai@gmail.com."
                }
            ]
        }
    },
    UserDetail: {
        userInfo: {
            emailLabel: "E-mail",
            createdAt: "Date de création",
            noRecord: "Aucun enregistrement",
            loginTime: "Heure de connexion",
        },
        orders: {
            title: "Historique des commandes",
            loading: "Chargement...",
            refresh: "Actualiser",
            orderAmount: "Montant",
            points: "Points",
            createdAt: "Date de création",
            orderType: "Type",
            status: "Statut",
            noOrders: "Aucune commande",
            goToSubscription: "Acheter des points",
            freeCredit: "Crédit gratuit",
            paidCredit: "Crédit payé",
            queryOrderFailed: "Échec de la requête de commande",
            statusPaid: "Payé",
            statusPending: "En attente",
            statusCancelled: "Annulé",
            statusDeactivated: "Désactivé",
            checkoutUrlNotAvailable: "Impossible d'obtenir l'URL de paiement",
            verifyingPayment: "Vérification du statut de paiement...",
            paymentSuccess: "Paiement réussi",
            paymentPending: "La commande est en attente de paiement, veuillez finaliser le paiement",
            paymentFailed: "Paiement échoué ou annulé",
            paymentStatus: "Statut de paiement",
            paymentStatusDescription: "Avez-vous terminé le paiement?",
            cancelPayment: "Annuler le paiement",
            completedPayment: "Paiement terminé",
            warning: "Avertissement",
            confirmCancelOrder: "Êtes-vous sûr de vouloir annuler cette commande? Cette action ne peut pas être annulée.",
            cancel: "Annuler",
            confirm: "Confirmer",
            cancellingOrder: "Annulation de la commande...",
            orderCancelledSuccess: "Commande annulée",
            cancelOrderFailed: "Échec de l'annulation de la commande",
            checkOrderStatusFailed: "Échec de la vérification du statut de la commande",
            promptClick: "Cliquez sur le statut \"En attente\" pour continuer le paiement",
        }
    },
    UserFeedback: {
        title: "Témoignages d'utilisateurs",
        feedback: "Écoutez les évaluations authentiques de créateurs et professionnels du monde entier concernant notre technologie de traitement d'images par IA.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "M. Lin",
                profession: "Monteur vidéo & créateur de contenu",
                rating: 5,
                comment: "Incroyable ! ClixMagicAI est ultra rapide ! Téléchargez une vidéo avec filigrane, en quelques minutes vous obtenez une version sans filigrane, sans aucune perte de qualité. Un outil indispensable pour supprimer les filigranes !"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Mme Su",
                profession: "Experte en médias sociaux",
                rating: 5,
                comment: "ClixMagicAI a sauvé ma bibliothèque de contenus Instagram ! Il identifie avec précision même les filigranes complexes, le traitement des bords est beaucoup plus raffiné que les logiciels que j'utilisais avant, rendant l'effet visuel plus naturel."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "M. Chen",
                profession: "Producteur de vidéos courtes",
                rating: 5,
                comment: "La suppression de filigrane avec ClixMagicAI est ultra pratique. Je traite mes contenus TikTok pendant mon trajet, et à l'arrivée au bureau je télécharge directement la version haute définition. L'efficacité est doublée ! Une bénédiction pour les créateurs de contenu."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "M. Huang",
                profession: "Designer graphique & directeur créatif",
                rating: 5,
                comment: "En tant que designer, je suis très satisfait ! Lors du traitement d'images avec logos clients, la texture d'arrière-plan est restaurée de façon très naturelle, sans aucune trace de Photoshop, ce qui économise beaucoup de temps de post-traitement."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Mme Emily",
                profession: "Créatrice de contenu numérique indépendante",
                rating: 5,
                comment: "J'ai découvert un trésor ! L'abonnement est beaucoup moins cher que d'autres produits de suppression de filigrane sur le marché, mais les résultats sont meilleurs, particulièrement lors du traitement de filigranes transparents dégradés où l'avantage est évident."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "M. Robertson",
                profession: "Producteur de formation d'entreprise",
                rating: 5,
                comment: "ClixMagicAI est très pratique car il ne nécessite pas d'installation ! Les restrictions de droits sur l'ordinateur de l'entreprise empêchent d'installer des logiciels, maintenant je peux traiter le matériel de cours avec le navigateur, n'importe quand et n'importe où."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Mme Zhou",
                profession: "Femme au foyer & éditrice d'images communautaires",
                rating: 5,
                comment: "L'interface est si simple que même ma grand-mère pourrait l'utiliser ! Ceux qui n'ont pas le temps d'apprendre des logiciels professionnels comme Photoshop devraient absolument essayer ClixMagicAI, c'est parfait pour les débutants techniques comme moi. Haha~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "M. Johnson",
                profession: "Planificateur visuel e-commerce",
                rating: 5,
                comment: "ClixMagicAI est extrêmement puissant, capable de supprimer des images, vidéos, petits objets, passants, textes, etc. Les fonctionnalités sont complètes, je le recommande à tous~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Mme Fang",
                profession: "Passionnée de photographie & partageuse de contenu en ligne",
                rating: 5,
                comment: "Wow~ J'ai enfin trouvé un outil de suppression de filigrane qui ne dégrade pas la qualité d'image ! C'est comme de la magie~ Éditer des photos n'est plus un problème ! Je le recommande vivement !!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "M. Williams",
                profession: "Formateur en éducation en ligne",
                rating: 5,
                comment: "La fonction de mémorisation de position du filigrane est ultra utile ! Lors du traitement de séries de vidéos de cours, je n'ai pas besoin de sélectionner répétitivement la zone, économisant au moins une demi-heure de travail, améliorant considérablement mon efficacité de préparation pédagogique."
            }
        ]
    },
    Order: {
        purchasePoints: "Acheter des points",
        subtitle: "Choisissez un forfait pour profiter de notre service de suppression de filigranes",
        loginReminderDesc: "Connectez-vous pour acheter",
        freeTag: "Gratuit",
        freePlan: "Plan gratuit",
        autoActivated: "Activation automatique",
        points: "Points",
        autoIncluded: "Offert",
        discount: "Remise",
        purchase: "Acheter",
        paymentStatusDescription: "Avez-vous terminé le paiement ?",
        paymentNotCompleted: "Paiement incomplet",
        queryOrderFailed: "Échec de la vérification",
        cancelPayment: "Annuler",
        completedPayment: "Terminé",
        warning: "Attention",
        confirmCancelOrder: "Voulez-vous annuler cette commande ? Cette action est irréversible.",
        cancel: "Annuler",
        confirm: "Confirmer",
        selectProductFirst: "Sélectionnez d'abord un forfait",
        creatingOrder: "Création de la commande...",
        orderCreated: "Commande créée",
        createOrderFailed: "Échec de création",
        checkoutUrlNotAvailable: "Lien de paiement indisponible",
        cancellingOrder: "Annulation...",
        orderCancelledSuccess: "Commande annulée",
        cancelOrderFailed: "Échec d'annulation",
        verifyingPayment: "Vérification du statut...",
        paymentSuccess: "Paiement réussi",
        paymentPending: "Paiement en attente",
        paymentFailed: "Paiement échoué",
        checkOrderStatusFailed: "Échec de vérification",
        quickStart: "Démarrage",
        shortTerm: "Court terme",
        recommended: "Recommandé",
        bestValue: "Meilleur prix",
    },
    Login: {
        title: "Connexion",
        subtitle: "Connexion rapide avec comptes sociaux",
        memberTip: "Connectez-vous pour plus de fonctionnalités",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Connexion avec GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Connexion avec Google"
            }
        ],
        error: {
            serverError: "Erreur serveur, réessayez plus tard",
            networkError: "Erreur réseau, vérifiez votre connexion"
        }
    },
    OAuthCallback: {
        loading: "Traitement de la connexion",
        pleaseWait: "Patientez, vérification...",
        error: "Échec de connexion",
        backToHome: "Retour à l'accueil",
        success: "Connexion réussie",
        redirecting: "Redirection vers l'accueil..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Tarifs",
            faq: "Questions fréquentes",
        },
        login: "Connexion",
        userMenu: {
            account: "Compte",
            logout: "Déconnexion",
            credit: "Crédits",
            freeCredit: "Gratuit",
            paidCredit: "Acheté",
            nextUpdate: "Prochaine mise à jour",
            language: "Langue",
            theme: "Thème",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "Fonctionnalités de ClixMagicAI",
        advs: [
            {
                title: "Moteur de reconnaissance IA : Détection automatique des éléments gênants",
                desc: "Basé sur des algorithmes d'apprentissage profond, identifie automatiquement les filigranes, textes, visages et éléments complexes dans les images/vidéos, sans marquage manuel. Compatible avec Instagram, TikTok et autres plateformes, avec une protection stricte des données privées.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Supprimer filigrane"
            },
            {
                title: "Nettoyeur d'images expert : Supprime logos/horodatages instantanément, qualité préservée",
                desc: "Élimine avec précision les filigranes de marque, dates de prise de vue, autocollants et autres éléments. L'IA restaure automatiquement la texture d'arrière-plan, les images traitées paraissent naturelles comme l'original, parfaites pour les publications sur réseaux sociaux.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Supprimer filigrane"
            },
            {
                title: "Éliminateur de filigranes dynamiques : Efface sous-titres/logos de plateforme",
                desc: "Supprime en un clic les écrans de fin YouTube, filigranes TikTok et textes défilants. L'IA suit et traite chaque image, produisant des vidéos 4K fluides de haute qualité, compatible avec MP4/MOV et autres formats courants.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Supprimer filigrane"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Un outil professionnel alimenté par IA pour supprimer rapidement les filigranes des images et vidéos.",
        fileTypes: {
            image: 'Supprimer des images',
            pdf: 'Supprimer des PDF',
            video: 'Supprimer des vidéos'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Essai gratuit quotidien", icon: "fa-gift" },
            { id: "imageTag", text: "Images sans filigrane", icon: "fa-image" },
            { id: "videoTag", text: "Vidéos sans filigrane", icon: "fa-video" },
            { id: "aiPoweredTag", text: "Alimenté par IA", icon: "fa-robot" },
            { id: "noRegTag", text: "Connectez et utilisez", icon: "fa-user-check" },
        ],
        videoPromt: "Bientôt disponible !",
        videoDesc: "Nous développons la suppression de filigrane vidéo pour vous offrir une expérience plus puissante."
    },
    Footer: {
        social: {
            title: "Contactez-nous",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:clixmagicai@gmail.com",
                    text: "clixmagicai@gmail.com"
                },
            ]
        },
        termsTitle: "Mentions légales",
        terms: [
            {
                id: 1,
                title: "Confidentialité",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Conditions",
                link: "/terms"
            },
            {
                id: 3,
                title: "Cookies",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI. Tous droits réservés."
    },
    Task: {
        image: {
            imageSupportText: 'Formats jpg, jpeg, png, webp, heic, heif supportés, max 10Mo par fichier',
            imageFileTooLarge: 'Fichier trop volumineux (max 10Mo)',
            invalidImageType: 'Format non supporté, utilisez JPG, JPEG, PNG, WEBP, HEIC ou HEIF',
            imageWillCost: 'Coût : 1 point',
            hiecSupportText: 'Formats HEIC/HEIF automatiquement convertis en PNG',
            hiecSuccess: 'Conversion HEIC/HEIF réussie',
            hiecFailed: 'Échec de conversion HEIC/HEIF',
            processingImageTip: 'Traitement en cours, patientez...',
            guide: {
                title: 'Guide',
                step1: 'Importez la vidéo',
                step2: 'Marquez la zone ou laissez IA identifier le filigrane',
                step3: 'Cliquez sur soumettre'
            }
        },
        common: {
            remaining: 'Points restants',
            nextUpdate: 'Prochaine mise à jour',
            handleError: 'Erreur de traitement, essayez un autre fichier',
            uploadFailed: 'Échec importation',
            dragText: 'Glissez les fichiers ici ou',
            clickText: 'cliquez pour importer',
            loginRequired: 'Connectez-vous avant importer',
            noRemainingTasks: 'Vous avez utilisé tous vos points',
            loginNow: 'Se connecter',
            upgradeNow: 'Acheter des points',
            taskSubmitSuccess: 'Tâche soumise',
            taskSubmitError: 'Échec de soumission',
            taskRetrySuccess: 'Nouvelle tentative réussie',
            taskRetryError: 'Échec de nouvelle tentative',
            processing: 'Traitement',
            submit: 'Soumettre',
            waiting: 'En attente',
            completed: 'Terminé',
            failed: 'Échoué',
            cancelled: 'Annulé',
            url_not_found: 'Lien introuvable',
            deleted: 'Supprimé',
            refreshSuccess: 'Liste actualisée',
            refreshFailed: 'Échec actualisation',
            deleteSuccess: 'Tâche supprimée',
            deleteFailed: 'Échec de suppression',
            waitingForCompletion: 'Attendez la fin de la tâche actuelle',
            loadOriginalImageFailed: 'Échec de chargement image originale',
            downloadFailed: 'Échec de téléchargement',
            startingDownload: 'Téléchargement...',
            noTasks: 'Aucune tâche',
            refresh: 'Actualiser',
            sort: 'Trier',
            noFilterTasks: 'Aucune tâche {filter}',
            compare: 'Comparer',
            originalImage: 'Original',
            processedImage: 'Traité',
            dragToCompare: '👈 Glissez pour comparer 👉',
            cancel: "Annuler",
            delete: "Supprimer",
            retry: "Réessayer",
            download: "Télécharger",
            createAt: "Créé le",
            expiredAt: "Expire le",
        },
        video: {
            videoSupportText: 'Formats mp4, mov, avi, mkv supportés, max 100Mo par fichier',
            videoFileTooLarge: 'Fichier trop volumineux (max 100Mo)',
            invalidVideoType: 'Format non supporté, utilisez MP4, MOV, AVI ou MKV',
            videoWillCost: 'Coût : 3 points',
            processingVideoTip: 'Traitement en cours, patientez...',
            guide: {
                step1: 'Importez la vidéo',
                step2: 'Sélectionnez le type et définissez la zone',
                step3: 'Cliquez sur soumettre'
            },
            annotationTools: 'Outils de marquage',
            selectType: 'Type de filigrane',
            deleteAnnotation: 'Supprimer',
            clearAllAnnotations: 'Tout effacer',
            annotationHelp: 'Aide',
            dragTip: 'Glissez pour dessiner la zone',
            resizeTip: 'Ajustez la taille pour correspondre',
            moveTip: 'Les marquages peuvent être déplacés',
            processing: 'Traitement',
            submit: 'Soumettre',
            taskSubmitSuccess: 'Tâche soumise',
            taskSubmitError: 'Échec de soumission',
            retryTaskTip: 'Nouvelle tentative réussie',
            retryFailed: 'Échec de nouvelle tentative',
            uploadFailed: 'Échec importation',
            staticWatermarkDesc: 'Pour filigranes statiques à position fixe',
            normalWatermarkDesc: 'Pour filigranes fixes standards',
            dynamicWatermarkDesc: 'Pour filigranes dynamiques changeants',
            moveWatermarkDesc: 'Pour filigranes nécessitant un déplacement'
        },
    },
    Router: {
        home: "Accueil",
        terms: "Conditions d'utilisation",
        privacy: "Politique de confidentialité",
        cookie: "Politique des cookies",
        user: "Centre d'utilisateur",
    },
    FAQ: {
        title: "Guide d'utilisation et questions fréquentes de ClixMagicAI",
        prompt: "Vous avez des problèmes ou des questions ? Contactez-nous à tout moment : clixmagicai@gmail.com",
        questions: [
            {
                id : 1,
                question: "Qu'est-ce que ClixMagicAI et comment ça fonctionne ?",
                answer: "ClixMagicAI est un outil avancé de suppression de filigrane alimenté par l'IA. Il prend en charge l'identification automatique des filigranes dans les images et les vidéos, et offre une fonction de marquage manuel des positions de filigrane. Pour les images, il prend en charge plusieurs formats de conversion et garantit une sortie de haute qualité ; pour les vidéos, il peut traiter des filigranes statiques, dynamiques et même à forme variable."
            },
            {
                id : 2,
                question: "ClixMagicAI offre-t-il une utilisation gratuite ?",
                answer: "Oui, nous offrons un service de base gratuit de 10 points par jour ! Vous pouvez les utiliser pour traiter des images (1 point par opération) ou des vidéos (3 points par opération). L'achat de points supplémentaires n'est pas pris en charge pour le moment, seuls les 10 points gratuits quotidiens sont disponibles."
            },
            {
                id : 3,
                question: "Puis-je acheter des points supplémentaires ?",
                answer: "À ce stade, l'achat de points supplémentaires n'est pas pris en charge. Chaque utilisateur ne peut obtenir que 10 points gratuits par jour, qui sont renouvelés automatiquement le lendemain."
            },
            {
                id : 4,
                question: "Quels formats de fichiers sont pris en charge ?",
                answer: "Pour les images, nous prenons en charge les formats PNG, JPEG, JPG, WEBP, HEIC et HEIF, où HEIC et HEIF seront automatiquement convertis en PNG. Pour les vidéos, nous prenons en charge plusieurs formats, dont MP4 et MOV."
            },
            {
                id : 5,
                question: "Comment ma vie privée est-elle protégée ?",
                answer: "Chez ClixMagicAI, nous accordons une grande importance à la confidentialité des utilisateurs. Tous les fichiers téléchargés sont cryptés et automatiquement supprimés 24 heures après la fin du traitement. Nous ne conservons aucun fichier utilisateur ni information associée."
            },
            {
                id : 6,
                question: "Comment puis-je me connecter à ClixMagicAI ?",
                answer: "Nous prenons en charge la connexion rapide via les comptes GitHub ou Google, garantissant la sécurité de votre compte tout en simplifiant le processus d'inscription."
            },
            {
                id : 7,
                question: "Quelle est la vitesse de traitement ?",
                answer: "Grâce à nos serveurs haute performance et nos algorithmes d'IA optimisés, la plupart des tâches de suppression de filigrane d'image sont terminées en 10 secondes, tandis que la suppression de filigrane vidéo peut prendre aussi peu que 1 minute. Le temps réel peut varier en fonction de la taille et de la complexité du fichier."
            },
            {
                id : 8,
                question: "Comment sont les résultats du traitement ?",
                answer: "Nos modèles d'IA sont largement formés pour supprimer intelligemment les filigranes des images et des vidéos, tout en maintenant la qualité du contenu original. Les filigranes identifiés automatiquement et marqués manuellement sont efficacement supprimés, garantissant des résultats naturels sans trace."
            },
            {
                id : 9,
                question: "Quelle est la durée de validité de chaque tâche ?",
                answer: "Une fois la tâche terminée, les fichiers traités restent disponibles sur ClixMagicAI pendant 24 heures pour le téléchargement. Après cette période, les fichiers sont automatiquement supprimés de nos serveurs pour protéger votre vie privée."
            },
            {
                id : 10,
                question: "Quelle est la limite de taille maximale des fichiers ?",
                answer: "Nous acceptons des images jusqu'à 10 Mo et des fichiers vidéo jusqu'à 100 Mo. Les fichiers dépassant ces limites peuvent nécessiter une compression ou un recadrage avant d'être téléchargés."
            }
        ]
    }
}